import React, { Component } from 'react';

import LegacyFooter from 'legacy-usp/src/footer/components/Footer';
import PropTypes from 'prop-types';

export default class Footer extends Component {
    static defaultProps = {
        footerConfig: null,
        legacyFooterConfig: null,
        appConfig: null
    };

    static propTypes = {
        footerConfig: PropTypes.instanceOf(Object),
        legacyFooterConfig: PropTypes.instanceOf(Object),
        appConfig: PropTypes.instanceOf(Object),
    };

    state = {};

    render() {
        const { footerConfig } = this.state;
        const { legacyFooterConfig, appConfig } = this.props;

        if (footerConfig || legacyFooterConfig) {
            return (
                <React.Fragment>
                    <div id="footerSibling" style={{ paddingBottom: '20px' }} />
                    <LegacyFooter
                        appConfig={appConfig}
                        config={footerConfig || legacyFooterConfig}
                        context={process.env.REACT_APP_CONTEXT}
                    />
                </React.Fragment>
            );
        }

        return null;
    }

    componentDidUpdate(prevProps) {
        const { footerConfig } = this.props;

        if (footerConfig === prevProps.footerConfig) {
            return;
        }
        this.setFooterConfig();
    }

    componentDidMount() {
        this.setFooterConfig();
    }

    setFooterConfig() {
        const { footerConfig } = this.props;

        if (!footerConfig) {
            return;
        }
        const { staticText, textLinks, links, speedbumpConfig } = footerConfig;
        const staticReactContext = process.env.REACT_APP_CONTEXT;

        const fiFooterLinks = (links || []).map((linkObj) => {
            const { image, link, alt } = linkObj;
            let correctedImage = image;

            if (image && image.indexOf('$!staticResourcesContext') !== -1) {
                correctedImage = image.replace(
                    '$!staticResourcesContext',
                    staticReactContext.substring(
                        0,
                        staticReactContext.length - 1,
                    ),
                );
            }

            return {
                link,
                alt,
                class: 'confirmExternalLink',
                image: correctedImage,
            };
        });

        const fiFooterTextLinks = (textLinks || []).map((textLink) => {
            const childLinks = (textLink.links || []).map((link) => {
                return {
                    url: link.linkUrl,
                    text: link.linkText,
                };
            });

            childLinks.push({
                header: textLink.headerName,
                staticContent: textLink.staticContent,
            });

            return {
                links: childLinks,
            };
        });

        const legacyConfig = {
            speedbumpConfig,
            fiFooterLinks,
            fiFooterTextLinks,
            fiFooterStaticText: staticText,
        };

        this.setState({ footerConfig: legacyConfig });
    }
}
